exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-link.active[data-v-7ba967c0]{background-color:rgba(55,125,255,.1);color:#377dff;font-weight:600}.nav-icon[data-v-7ba967c0]{font-size:1.1rem}.dropdown-header[data-v-7ba967c0]{text-transform:uppercase;font-size:.75rem;letter-spacing:.05rem;color:#8c98a4;padding-left:1rem}", ""]);

// exports
